import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {COLORS} from "../../ui/Theme";
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';

const ProfileSubscriptionRemainedDays = ({data}) => {

    return (
        <Box sx={{
            display: "flex",
            gap: "30px",
        }}>
            <Box sx={{width: "80px"}}>
                <CircularProgressbar
                    counterClockwise={true}
                    value={data.remained_days}
                    maxValue={data.total_days}
                    text={data.remained_days ? data.remained_days + " " + "روز" : "اتمام"}
                    styles={buildStyles({
                        pathColor: data.remained_days ? COLORS.BLUE : COLORS.GRAY,
                        textColor: COLORS.BLACK,
                        trailColor: COLORS.SOFTGRAY,
                        textSize: '14px',
                    })}
                />
            </Box>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "5px"
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        اشتراک:
                    </Typography>
                    <Typography sx={{
                        fontSize: "14px",
                        color: COLORS.BLACK,
                        fontWeight: "bold"
                    }}>
                        {data.feature_name}
                    </Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        تاریخ شروع:
                    </Typography>
                    <Typography sx={{
                        fontSize: "14px",
                        color: COLORS.BLACK,
                        fontWeight: "bold"
                    }}>
                        {data.start_at_shamsi}
                    </Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        تاریخ پایان:
                    </Typography>
                    <Typography sx={{
                        fontSize: "14px",
                        color: COLORS.BLACK,
                        fontWeight: "bold"
                    }}>
                        {data.end_at_shamsi}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default ProfileSubscriptionRemainedDays;